import { Button as FloraButton, Grid } from '@grupoboticario/flora-react';
import { ButtonGhost, Card, Text } from 'ui/components/primitives';
import { mixins, styled, theme, utils } from 'ui/theme';

export const DigitalGuide = {
  GridGuide: styled(Grid)`
    display: grid;
  `,
  Container: styled('div')`
    width: 100%;
    border-radius: 8px;
    background-color: ${theme.colors.build.lightLight};
    padding: 16px;
  `,

  TitleContainer: styled('div')`
    display: flex;
    flex-direction: row;
    align-items: center;
    ${utils.media.max('s')`
        justify-content: space-between;
    `}
  `,

  Title: styled('span')`
    font-family: Sofia Pro;
    font-weight: 700;
    font-size: 24px;
    line-height: 32px;
  `,

  SeeAllButton: styled(ButtonGhost)`
    font-family:
      Space Grotesk,
      -apple-system,
      BlinkMacSystemFont,
      Segoe UI,
      Helvetica,
      Arial,
      sans-serif,
      Apple Color Emoji,
      Segoe UI Emoji,
      Segoe UI Symbol;
    margin-left: 20px;
    padding: 10px;
    height: auto;
    :focus-visible {
      box-shadow: inset 0 0 0 1px ${theme.colors.action.navigation.standard.static};
    }

    :hover {
      text-decoration: none;
    }
  `,

  SubTitle: styled(Text)`
    margin-top: 20px;
  `,

  ShareContainer: styled('div')`
    width: 100%;
    height: 80px;
    background-color: ${theme.colors.build.lightDark1};
    padding-right: 20px;
    border-radius: 8px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    ${utils.media.max('s')`
        height: 100px;
        padding: 10px;
        flex-flow: column wrap;
        align-items: flex-start;
        margin-top: 20px;
    `}
  `,

  ImgGuide: styled('img')`
    width: 60px;
    height: 80px;
  `,

  CicleText: styled('span')`
    font-size: 16px;
    font-weight: 700;
    line-height: 20px;
    font-family: Sofia Pro;
    color: ${theme.colors.build.darkLight};
    margin-left: 10px;
    ${utils.media.max('s')`
        margin-left: 0px;
    `}
  `,

  ShareButton: styled(FloraButton)`
    font-family:
      Space Grotesk,
      -apple-system,
      BlinkMacSystemFont,
      Segoe UI,
      Helvetica,
      Arial,
      sans-serif,
      Apple Color Emoji,
      Segoe UI Emoji,
      Segoe UI Symbol;
    ${utils.media.max('s')`
        padding: 10px;
    `}
    :focus-visible {
      box-shadow: none;
    }
  `,
};

export const GuideCarouselItems = {
  Card: styled(Card)`
    ${mixins.baseFont};
    align-items: end;
    color: ${theme.colors.build.darkLight};
    max-width: ${theme.screens.s};
    overflow: hidden;
    height: 8rem;
  `,
  Container: styled('div')`
    display: grid;
    grid-template-columns: 64px 212px;
    column-gap: 12px;
  `,
  Content: styled('div')`
    > svg {
      height: ${theme.sizes[4]};
      margin-bottom: ${theme.sizes[1]};
    }
  `,
  ButtonContainer: styled('div')``,

  DivImg: styled('div')`
    display: grid;
    align-items: center;
  `,

  ImgGuide: styled('img')`
    width: 64px;
    max-height: 91px;
  `,
  CycleInfo: styled('div')`
    display: flex;
    flex-direction: column;
    font-size: 0.875rem;
    span {
      margin-bottom: 7px;
    }
  `,
};
